import { GUEST_USER } from '../constants';
import { ItemDetails } from '../models/item.model';
import { locationMenuService } from '../services';

export async function fetchNestedMenuItemForTray(params: {
  location_id: string;
  category_id: string;
  item_id: string;
  user?: { id?: number; type?: string | null };
}): Promise<ItemDetails | null> {
  const { location_id, category_id, item_id, user } = params;
  if (
    !location_id ||
    category_id == null ||
    String(category_id).length === 0 ||
    !item_id
  ) {
    return null;
  }
  try {
    const payload: Record<string, unknown> = {
      location_id,
      category_id,
      item_id,
    };
    if (user?.type !== GUEST_USER && user?.id != null) {
      payload.customer_id = user.id;
    }
    const response = await locationMenuService.getLocationMenuItem(payload);
    const category = response?.data?.data?.categories?.[0];
    const fetched = category?.items?.[0] as ItemDetails | undefined;
    if (!fetched) {
      return null;
    }
    const groups = fetched.items_required_modifier_groups;
    const sorted =
      groups?.map((group) => ({
        ...group,
        required_modifiers_groups_modifiers: [
          ...(group.required_modifiers_groups_modifiers || []),
        ].sort((a, b) => Number(b.in_item) - Number(a.in_item)),
      })) ?? fetched.items_required_modifier_groups;
    return {
      ...fetched,
      ...(sorted && { items_required_modifier_groups: sorted }),
      basePrice: category?.base,
    } as ItemDetails;
  } catch {
    return null;
  }
}

export function mergeSandwichTrayMenuFields(
  base: ItemDetails,
  full: ItemDetails | null
): ItemDetails {
  if (!full) {
    return base;
  }
  return {
    ...base,
    sub_items_required_modifier_groups:
      full.sub_items_required_modifier_groups ??
      base.sub_items_required_modifier_groups,
    items_required_modifier_groups:
      full.items_required_modifier_groups ??
      base.items_required_modifier_groups,
    items_modifier_groups:
      full.items_modifier_groups ?? base.items_modifier_groups,
    core_modifiers: full.core_modifiers ?? base.core_modifiers,
    complementary_items: full.complementary_items ?? base.complementary_items,
    bucket: full.bucket ?? base.bucket,
  } as ItemDetails;
}
